import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = (location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    window.history.replaceState(null, "", location.pathname);
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    loginWithGoogle(sessionId)
      .then(() => navigate("/", { replace: true }))
      .catch((err) => {
        toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Falha no login com Google.");
        navigate("/login", { replace: true });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream" data-testid="auth-callback">
      <Loader2 className="w-8 h-8 animate-spin text-gold" />
    </div>
  );
}
